module.exports = __webpack_public_path__ + "static/media/brand-img-6.ea348211.png";